import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdguardComponent } from './simple-icons-adguard.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdguardComponent ],
    exports:      [ SimpleIconsAdguardComponent ],
    bootstrap:    []
})
export class SimpleIconsAdguardModule {}
